<template>
  <div class="edit-share-part-sns-select-box">
    <div class="common-select">
      <select
        v-model="selectedValue"
        @input="updateValue($event.target.value)"
      >
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'type', // add or change
    'partExistsSns',
  ],
  data () {
    return {
      selectedValue: null,
    }
  },
  computed: {
    options () {
      const options = [
        { text: 'X', value: 'X' },
        { text: 'Facebook', value: 'Facebook' },
        { text: 'LINE', value: 'LINE' },
      ]
      if (this.type === 'add') {
        // 選択可能SNSの中から、パーツに存在しないSNSを選択肢とする
        return options.filter(option => !this.partExistsSns.includes(option.value))
      } else {
        // 選択可能SNSの中から、パーツに存在しないSNSと、今選んでいるSNSを選択肢とする
        return options.filter(option => (!this.partExistsSns.includes(option.value)) || option.value === this.value)
      }
    }
  },
  methods: {
    initSelectedValue () {
      if (this.type === 'add') {
        // 選択肢の一番上を選んでいる状態にする
        this.selectedValue = this.options[0].value
        this.$emit('updateValue', this.selectedValue)
      } else {
        this.selectedValue = this.value
      }
    },
    updateValue (value) {
      this.$emit('updateValue', value)
    }
  },
  watch: {
    options () {
      this.initSelectedValue()
    },

  },
  mounted () {
    this.initSelectedValue()
  },
}
</script>

<style lang="scss" scoped>
.edit-share-part-sns-select-box {
  position: relative;
  height: 39px;
  .common-select {
    width: 180px;
  }
}
</style>
